import Entity from 'utilities/Entity';

class Training extends Entity {}

export default new Training();
